
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexz_59aFwr4_45SpaJN2EnAZ3yKnQwpOZ4_GYBlZZxWayIQMeta } from "/home/forge/ufudu.sonnenglas.net/releases/20250720205340/pages/index.vue?macro=true";
import { default as loginQyhcBTa_451hc0S4jK7Cf_45vxtJ2IpEtcdIfATa7QdelDMMeta } from "/home/forge/ufudu.sonnenglas.net/releases/20250720205340/pages/login.vue?macro=true";
import { default as inventoryg05NGlyT9VJWkNuYvrPHqbygRpVbnhHK6vXWXkWwO0kMeta } from "/home/forge/ufudu.sonnenglas.net/releases/20250720205340/pages/inventory.vue?macro=true";
import { default as shipments0w4Nn1IV7sPczo56Bc8gEJ1E8nQ4RQ3teooFYQI4ujkMeta } from "/home/forge/ufudu.sonnenglas.net/releases/20250720205340/pages/shipments.vue?macro=true";
import { default as completed_45shipmentsna5T_45BVNySLNn_4573g5rQOF_3hmv_45A7UjCFKg0kYvEkcMeta } from "/home/forge/ufudu.sonnenglas.net/releases/20250720205340/pages/completed-shipments.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/forge/ufudu.sonnenglas.net/releases/20250720205340/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginQyhcBTa_451hc0S4jK7Cf_45vxtJ2IpEtcdIfATa7QdelDMMeta || {},
    component: () => import("/home/forge/ufudu.sonnenglas.net/releases/20250720205340/pages/login.vue")
  },
  {
    name: "inventory",
    path: "/inventory",
    component: () => import("/home/forge/ufudu.sonnenglas.net/releases/20250720205340/pages/inventory.vue")
  },
  {
    name: "shipments",
    path: "/shipments",
    component: () => import("/home/forge/ufudu.sonnenglas.net/releases/20250720205340/pages/shipments.vue")
  },
  {
    name: "completed-shipments",
    path: "/completed-shipments",
    component: () => import("/home/forge/ufudu.sonnenglas.net/releases/20250720205340/pages/completed-shipments.vue")
  }
]